/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { PidxBannerService } from '@myprofile-ui/pidx-ui-components'
import { TranslateService } from '@ngx-translate/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { HttpErrorHandler } from '../services/error-utils/http-error-handler'
import { NewRelicService, WINDOW } from '@myprofile-ui/pidx-utils'

const ERROR_500_MESSAGE = 'Seems like something went wrong. Sorry, the requested page is currently not available. Please come back later.'

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private notificationsService = inject(PidxBannerService)
  private translateService = inject(TranslateService)
  private newRelicService = inject(NewRelicService)
  private window = inject<Window>(WINDOW)

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const traceId = req.headers?.get('X-TRACE-ID') || ''
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Forward the error to New Relic for monitoring
        this.newRelicService.noticeError(error, traceId)

        if (error.status >= 400 && error.status <= 499) {
          // A 4xx- Error occurred, do nothing
        } else if (error.url?.includes('experian')) {
          // since the Autocomplete API returns a 502, we have to avoid all error responses from this API for now.
          // The API will be changed in a future release
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          const errorMessage = this.translateService.instant(HttpErrorHandler.getErrorNotificationKeyByStatusCode(error.status))
          // if an error occurs when the configurations are requested, there are no translations available
          // should show a default error message
          if (errorMessage.indexOf('[missing]') !== -1) {
            this.notificationsService.addPageBlockingError(ERROR_500_MESSAGE)
          } else {
            this.notificationsService.addPageBlockingError(errorMessage)
          }
        }
        // If you want to return a new response:
        // return of(new HttpResponse({body: [{name: "Default value..."}]}));

        // If you want to return the error on the upper level:
        return throwError(error)
      }),
    )
  }
}

export const HttpInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpErrorInterceptor,
  multi: true,
}
